/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import SignContractResponse from '../model/SignContractResponse';

/**
* Susceptible service.
* @module api/SusceptibleApi
* @version 1.0.0
*/
export default class SusceptibleApi {

    /**
    * Constructs a new SusceptibleApi. 
    * @alias module:api/SusceptibleApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Acepta inicio del FFE
     * Acepta inicio del FFE
     * @param {Number} contractId ID del contrato
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/SignContractResponse} and HTTP response
     */
    apiV1MyaccountSusceptibleContractIdAcceptPostWithHttpInfo(contractId) {
      let postBody = null;
      // verify the required parameter 'contractId' is set
      if (contractId === undefined || contractId === null) {
        throw new Error("Missing the required parameter 'contractId' when calling apiV1MyaccountSusceptibleContractIdAcceptPost");
      }

      let pathParams = {
        'contract_id': contractId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = SignContractResponse;
      return this.apiClient.callApi(
        '/api/v1/myaccount/susceptible/{contract_id}/accept', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Acepta inicio del FFE
     * Acepta inicio del FFE
     * @param {Number} contractId ID del contrato
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/SignContractResponse}
     */
    apiV1MyaccountSusceptibleContractIdAcceptPost(contractId) {
      return this.apiV1MyaccountSusceptibleContractIdAcceptPostWithHttpInfo(contractId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Acepta inicio del FFE
     * Acepta inicio del FFE
     * @param {Number} contractId ID del contrato
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/SignContractResponse} and HTTP response
     */
    apiV1MyaccountSusceptibleContractIdRefusePostWithHttpInfo(contractId) {
      let postBody = null;
      // verify the required parameter 'contractId' is set
      if (contractId === undefined || contractId === null) {
        throw new Error("Missing the required parameter 'contractId' when calling apiV1MyaccountSusceptibleContractIdRefusePost");
      }

      let pathParams = {
        'contract_id': contractId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = SignContractResponse;
      return this.apiClient.callApi(
        '/api/v1/myaccount/susceptible/{contract_id}/refuse', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Acepta inicio del FFE
     * Acepta inicio del FFE
     * @param {Number} contractId ID del contrato
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/SignContractResponse}
     */
    apiV1MyaccountSusceptibleContractIdRefusePost(contractId) {
      return this.apiV1MyaccountSusceptibleContractIdRefusePostWithHttpInfo(contractId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
